import { config } from '../../config';
import { fetchWithAuth } from '../services/fetchWithAuth';

const jsonHeaders = { 'Content-Type': 'application/json' };
const base = () => config().geoExposureServiceBaseUrl;

async function parse(res) {
    if (!res.ok) {
        let detail = '';
        try {
            detail = await res.text();
            const { message } = JSON.parse(detail);
            detail = [].concat(message || []).join('; ') || detail;
        } catch {
            // not a Nest JSON error body — show it as-is
        }
        throw new Error(detail || res.statusText || `HTTP ${res.status}`);
    }
    return res.status === 204 ? null : res.json();
}

const call = (path, options = {}) =>
    fetchWithAuth(`${base()}${path}`, options.body ? { ...options, headers: jsonHeaders, body: JSON.stringify(options.body) } : options).then(parse);

export const geoExposureApi = {
    getSettings: () => call('/settings'),
    updateSettings: (patch) => call('/settings', { method: 'PUT', body: patch }),

    listQueries: () => call('/queries'),
    createQuery: (text) => call('/queries', { method: 'POST', body: { text } }),
    updateQuery: (id, patch) => call(`/queries/${id}`, { method: 'PUT', body: patch }),
    deleteQuery: (id) => call(`/queries/${id}`, { method: 'DELETE' }),
    regenerateRephrases: (id) => call(`/queries/${id}/rephrases/regenerate`, { method: 'POST' }),
    setRephrases: (id, texts) => call(`/queries/${id}/rephrases`, { method: 'PUT', body: { texts } }),
    getQueryHistory: (id) => call(`/queries/${id}/history`),

    listRuns: () => call('/runs'),
    startRun: () => call('/runs', { method: 'POST' }),
    getStats: () => call('/runs/stats'),
    getRun: (id, mention) => call(`/runs/${id}${mention && mention !== 'all' ? `?mention=${mention}` : ''}`),
    retryRun: (id) => call(`/runs/${id}/retry`, { method: 'POST' }),
    cancelRun: (id) => call(`/runs/${id}/cancel`, { method: 'POST' }),
    getRunQueryAnswers: (runId, queryId) => call(`/runs/${runId}/queries/${queryId}`),
};
